import React from "react";
import ConectaZapColoredIcon from "../../../components/icons/ConectaZapColoredIcon";
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";

const DeviceInfo = ({
  instance,
  alreadySelectedNotification,
  alreadySelectedChat,
  updateInstance,
  ...props
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        paddingLeft: 16,
        paddingRight: 16,
        borderRight: "1px solid #ccc",
        height: "100%",
        justifyContent: "center",
        gap: 16,
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <ConectaZapColoredIcon />
          <div
            style={{
              color: "#364461",
              fontWeight: 800,
              fontSize: 18,
              marginLeft: 8,
            }}
          >
            Conecte o WhatsApp ao seu computador
          </div>
        </div>
      </div>

      <ol style={{ marginLeft: 24 }}>
        <li>Abra o WhatsApp no seu celular.</li>
        <li>Toque em Mais opções (Android) ou Configurações (iPhone).</li>
        <li>
          Selecione Dispositivos Conectados e toque em Conectar um dispositivo.
        </li>
        <li>
          Aponte a câmera do seu celular para esta tela para escanear o QR Code.
        </li>
      </ol>

      <Grid container style={{ marginTop: 16 }}>
        <Grid item xs={6}>
          <FormControlLabel
            label={
              <div style={{ fontSize: 14, color: "#364461" }}>
                Usar esta conta para Conversas (Chat)
              </div>
            }
            control={
              <Checkbox
                color="primary"
                checked={instance?.flags?.chat}
                disabled={!instance?.flags?.chat && alreadySelectedChat}
                onChange={(ev) => {
                  updateInstance({
                    instance: instance,
                    value: ev.target.checked,
                    type: "chat",
                  });
                }}
              ></Checkbox>
            }
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            label={
              <div style={{ fontSize: 14, color: "#364461" }}>
                Usar esta conta para Notificações
              </div>
            }
            control={
              <Checkbox
                color="primary"
                checked={instance?.flags?.notifications}
                disabled={
                  !instance?.flags?.notifications && alreadySelectedNotification
                }
                onChange={(ev) => {
                  updateInstance({
                    instance: instance,
                    value: ev.target.checked,
                    type: "notifications",
                  });
                }}
              ></Checkbox>
            }
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default DeviceInfo;
